"use client";

import { useContext } from "react";

import { VariantContext } from "~/components/product/variant/context";

export function useVariant() {
  const context = useContext(VariantContext);
  if (!context) {
    throw new Error("useVariant must be used within a VariantProvider");
  }
  return context;
}
